<!-- Ported from the Polaris kit: src/components/ui/sidebar/SidebarRail.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';
import { useSidebar } from './utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const { toggleSidebar } = useSidebar();
</script>

<template>
  <!-- Polaris patch (woot): p-0 — the app's global CSS pads every button (4px 10px), which widened the rail and
       drew its hover line 5px off the tier-1 border. Re-porting reverts this; see README rule 20. -->
  <button
    data-sidebar="rail"
    data-slot="sidebar-rail"
    :aria-label="$t('POLARIS.SIDEBAR.TOGGLE')"
    :tabindex="-1"
    :title="$t('POLARIS.SIDEBAR.TOGGLE')"
    :class="
      cn(
        'hover:after:bg-polaris-sidebar-border absolute inset-y-0 z-20 hidden w-4 p-0 -translate-x-1/2 transition-all ease-linear group-data-[side=left]:-right-4 group-data-[side=right]:left-0 after:absolute after:inset-y-0 after:left-1/2 after:w-0.5 sm:flex',
        '[[data-side=left]_&]:cursor-w-resize [[data-side=right]_&]:cursor-e-resize',
        '[[data-side=left][data-state=collapsed]_&]:cursor-e-resize [[data-side=right][data-state=collapsed]_&]:cursor-w-resize',
        'hover:group-data-[collapsible=offcanvas]:bg-polaris-sidebar group-data-[collapsible=offcanvas]:translate-x-0 group-data-[collapsible=offcanvas]:after:left-full',
        '[[data-side=left][data-collapsible=offcanvas]_&]:-right-2',
        '[[data-side=right][data-collapsible=offcanvas]_&]:-left-2',
        props.class
      )
    "
    @click="toggleSidebar"
  >
    <slot />
  </button>
</template>
